import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const ReplyIcon = (p: IconProps) => <Icon {...p}><polyline points="9 17 4 12 9 7" /><path d="M20 18v-2a4 4 0 0 0-4-4H4" /></Icon>
